import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useTransitionComplaint } from "../../lib/api";
import { STAGE_META, allowedTransitions, visualStage } from "../../lib/complaints";
import { Btn } from "../msd/ui";

// One button, not a menu of every backend-allowed move: staff have exactly
// one decision to make from the group conversation -- resolve it. Advancing
// through Under Review/In Progress happens on its own (a staff reply already
// moves Logged -> Under Review), and auto-close handles Resolved -> Closed.
// Resolved is terminal -- no reopen, so once it's resolved there's nothing
// left to click here.
function primaryAction(complaint, options) {
  if (visualStage(complaint?.stage) === "resolved") return null;
  return options.find((o) => o.to === "resolved") || null; // Mark resolved
}

// Rendered only for roles that may manage complaints (the API decides that and
// enforces it again on every move).
export default function ComplaintActions({ row, complaint, reopenWindowDays }) {
  const transition = useTransitionComplaint(row);
  const options = allowedTransitions(complaint, { reopenWindowDays });
  const action = primaryAction(complaint, options);

  if (!action) return null;

  const run = async () => {
    try {
      await transition.mutateAsync({ complaintId: complaint.id, toStage: action.to, note: "" });
      toast.success(`Complaint #${complaint.complaint_no} is now ${STAGE_META[action.to]?.label.toLowerCase()}.`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update the complaint.");
    }
  };

  return (
    <Btn
      variant="pri"
      disabled={transition.isPending}
      onClick={run}
      data-testid={`complaint-actions-${complaint.complaint_no}`}
      className="self-start"
    >
      {transition.isPending && <Loader2 className="animate-spin" size={14} />}
      {action.label}
    </Btn>
  );
}
